<template>
  <BasePageContainer class="mandala-goal-templates">
    <SettingHeader>目標テンプレート管理</SettingHeader>
    <div class="pt-9 pb-11">
      <MandalaTemplateItem
        v-for="mandalaGoalTemplate in mandalaGoalTemplates"
        :key="mandalaGoalTemplate.id"
        class="mb-3"
        :mandala-goal-template="mandalaGoalTemplate" />
      <FixedBottomRightArea>
        <IconButton
          icon="add"
          width="62"
          height="62"
          icon-size="30"
          data-testid="mandala-goal-template-add-button"
          @click="() => $router.push('/admin/mandala_goal_templates/add')" />
      </FixedBottomRightArea>
    </div>
  </BasePageContainer>
</template>

<script>
import SettingHeader from '@/components/parts/SettingHeader.vue'
import MandalaTemplateItem from '@/components/view/mandala_goal_templates/MandalaGoalTemplateItem.vue'
import IconButton from '@/components/parts/IconButton.vue'
import FixedBottomRightArea from '@/components/parts/FixedBottomRightArea.vue'
export default {
  components: {
    SettingHeader,
    MandalaTemplateItem,
    IconButton,
    FixedBottomRightArea
  },
  data() {
    return {
      mandalaGoalTemplates: []
    }
  },
  async created() {
    this.$store.commit('startLoading')
    await this.fetchMandalaGoalTemplates()
    this.$store.commit('finishLoading')
  },
  methods: {
    fetchMandalaGoalTemplates() {
      return this.$axios.get('/mandala_goal_templates/', {
        params: {
          orderBy: 'display_order'
        }
      }).then(res => {
        this.mandalaGoalTemplates = res.data.results
      })
    }
  }
}
</script>
